<template v-if="text">
  <component :is="tag">
    <span>{{displayText}}</span>&nbsp;<span v-if="expandable" class="read-more" @click="toggle">{{expanded ? less : more}}</span>
  </component>
</template>

<script>
export default {
  name: 'mui-truncate',
  props: {
    text: String,
    clamp: {
      type: String,
      default: '…'
    },
    isTruncatable: {
      type: Boolean,
      default: true
    },
    length: {
      type: Number,
      default: 96
    },
    less: {
      type: String,
      default: 'less'
    },
    more: {
      type: String,
      default: 'read more'
    },
    tag: {
      type: String,
      default: 'p'
    }
  },
  computed: {
    contentLength () {
      var node = document.createElement('div')
      node.innerHTML = this.text
      var content = node.textContent
      return content.length
    },
    expandable () {
      return this.isTruncatable && this.contentLength > this.length + 24
    },
    displayText () {
      const truncatedText = this.text.slice(0, this.length).trim() + this.clamp
      return this.expandable && !this.expanded ? truncatedText : this.text
    }
  },
  data () {
    return {
      expanded: false
    }
  },
  methods: {
    reset () {
      this.expanded = false
    },
    toggle () {
      this.expanded = !this.expanded
      this.$emit('toggle')
    }
  },
  watch: {
    text () {
      this.reset()
    }
  }
}
</script>

<style lang="sass" scoped>
span.read-more
  cursor: pointer
  pointer-events: auto
p:last-child
  margin-bottom: 0
</style>



// WEBPACK FOOTER //
// src/components/MUITruncate.vue